// usePermission.js
export default function usePermission(formKey, fieldKey) {
    const raw = localStorage.getItem('permissions');
    if (!raw) return { hidden: false, disabled: false };

    const perms = JSON.parse(raw);
    const key = `${formKey}.${fieldKey}`;

    const actions = perms
        .filter(p => p.objectName === key)
        .map(p => p.action.toLowerCase());

    return {
        hidden: actions.includes('hide'),
        disabled: actions.includes('disable')
    };
}

// shared readers so can evaluate permissions without a React hook
export function getActions(formKey, fieldKey) {
    const raw = localStorage.getItem('permissions');
    if (!raw) return [];
    const perms = JSON.parse(raw);
    const key = `${formKey}.${fieldKey}`;
    return perms
        .filter(p => p.objectName === key)
        .map(p => p.action.toLowerCase());
}

export function hasAction(formKey, fieldKey, action) {
    return getActions(formKey, fieldKey).includes(action.toLowerCase());
}

//  group-level hook — hide only if *all* fields are hidden; disable only if *all* fields are disabled
export function usePermissionGroup(formKey, fieldKeys = []) {
    if (!Array.isArray(fieldKeys) || fieldKeys.length === 0) {
        return { hidden: false, disabled: false, visible: true, enabled: true };
    }

    const allHidden = fieldKeys.every(f => hasAction(formKey, f, 'hide'));
    const allDisabled = fieldKeys.every(f => hasAction(formKey, f, 'disable'));

    return {
        hidden: allHidden,
        disabled: allDisabled,
        visible: !allHidden,
        enabled: !allDisabled,
    };
}

// quick helpers for convenience
export function canSeeAny(formKey, fieldKeys = []) {
    return fieldKeys.some(f => !hasAction(formKey, f, 'hide'));
}

export function allDisabled(formKey, fieldKeys = []) {
    return fieldKeys.every(f => hasAction(formKey, f, 'disable'));
}

// Sidebar navigation (Table Permissions: Nav.item.<key>)
export function isNavItemHidden(navKey) {
    return hasAction('Nav', `item.${navKey}`, 'hide');
}

export function isNavItemVisible(navKey) {
    return !isNavItemHidden(navKey);
}
